import React from "react";
import { cx } from "@linaria/core";
import {
  inputClass,
  FormInput,
  InputWrapper,
  Label,
  CheckmarkIcon,
  ErrorIcon,
  InputContainer,
  CaptionContainer,
  DescriptionContainer,
  ErrorMessageContainer,
  CharacterCountContainer,
  ClearButton
} from "./Input.styles";
const defaultProps = {
  label: "",
  description: "",
  value: "",
  error: "",
  touched: false,
  className: "",
  mode: "light",
  testId: "Input",
  showCharCount: false,
  InputComponent: FormInput
};
const noop = (f) => f;
export class Input extends React.PureComponent {
  constructor(props) {
    super(props);
    const { value } = props;
    const hasValueProp = this.hasValidValue(value);
    this.state = {
      inputValue: value,
      hasValue: hasValueProp
    };
    this.onInputFocus = this.onInputFocus.bind(this);
    this.onInputBlur = this.onInputBlur.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.handleAutofill = this.handleAutofill.bind(this);
  }
  componentDidUpdate(prevProps) {
    const { value } = this.props;
    if (prevProps.value !== value) {
      this.setState({ hasValue: this.hasValidValue(value) });
    }
  }
  handleAutofill(e) {
    if (e.animationName === "onAutoFillStart") {
      this.setState({ hasValue: true });
    }
    if (e.animationName === "onAutoFillCancel") {
      const { inputValue } = this.state;
      this.setState({ hasValue: this.hasValidValue(inputValue) });
    }
  }
  onInputBlur(e) {
    const { onBlur } = this.props;
    if (onBlur)
      onBlur(e);
  }
  onInputChange(e) {
    const { sanitize } = this.props;
    const sanitizeFn = sanitize || noop;
    const newValue = sanitizeFn(e.target.value);
    this.setState({
      inputValue: newValue,
      hasValue: this.hasValidValue(newValue)
    });
  }
  onInputFocus(e) {
    const { onFocus } = this.props;
    if (onFocus)
      onFocus(e);
  }
  hasValidValue(v) {
    return v.toString().length > 0;
  }
  render() {
    const {
      id,
      label,
      description,
      onChange,
      onBlur,
      onClear,
      value,
      error,
      touched,
      testId,
      className,
      children,
      mode,
      width,
      inputRef,
      showCharCount,
      InputComponent,
      maskInputValue,
      ...restProps
    } = this.props;
    const { inputValue, hasValue } = this.state;
    const hasValueProp = this.hasValidValue(value);
    const isValid = !error && touched && hasValueProp;
    const shouldShowError = error && touched;
    const isFieldPopulated = hasValue || hasValueProp;
    const hasDescription = (description || "").length > 0;
    const shouldShowCount = showCharCount && restProps.maxLength !== void 0;
    const classNames = cx(shouldShowError && "show-error-icon", (hasValue || hasValueProp) && "is-populated", label?.length && "has-label", mode === "dark" && "dark-mode", maskInputValue && "fs-mask", inputClass);
    const inputProps = {
      id,
      value: onChange ? value : inputValue,
      onBlur: onBlur || this.onInputBlur,
      onChange: onChange || this.onInputChange,
      onFocus: this.onInputFocus,
      label,
      onAnimationStart: this.handleAutofill,
      ...restProps
    };
    return /* @__PURE__ */ React.createElement(InputWrapper, {
      width,
      className,
      "data-testid": testId
    }, /* @__PURE__ */ React.createElement(InputContainer, null, /* @__PURE__ */ React.createElement(InputComponent, {
      type: "text",
      className: classNames,
      mode,
      ref: inputRef,
      ...inputProps
    }), /* @__PURE__ */ React.createElement(Label, {
      htmlFor: id
    }, label), isValid && isFieldPopulated && /* @__PURE__ */ React.createElement(CheckmarkIcon, null), shouldShowError && /* @__PURE__ */ React.createElement(ErrorIcon, null), onClear && isFieldPopulated && /* @__PURE__ */ React.createElement(ClearButton, {
      type: "button",
      onClick: onClear,
      "data-testid": "clear-button"
    }, "Clear"), children), (shouldShowError || hasDescription || shouldShowCount) && /* @__PURE__ */ React.createElement(CaptionContainer, {
      className: "input__caption"
    }, (shouldShowError || hasDescription) && /* @__PURE__ */ React.createElement("div", null, shouldShowError && /* @__PURE__ */ React.createElement(ErrorMessageContainer, null, error), hasDescription && !shouldShowError && /* @__PURE__ */ React.createElement(DescriptionContainer, null, description)), shouldShowCount && /* @__PURE__ */ React.createElement(CharacterCountContainer, null, `Remaining: ${(inputProps.maxLength || 0) - (Array.isArray(inputProps.value) ? inputProps.value.join("") : inputProps.value.toString()).length}`)));
  }
}
Input.defaultProps = defaultProps;
export default React.forwardRef((props, ref) => /* @__PURE__ */ React.createElement(Input, {
  ...props,
  inputRef: ref
}));
